import React from 'react'
import { Box, Grid, Stack } from "@mui/material";

function Heading({ title,icon=false ,svg=false,children }) {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        spacing={2}
        className="d-flex align-items-center justify-content-space-between"
      >
        <Grid item xs={children ? 4 : 12} md={children ? 4 : 12} className="d-flex align-items-center">
          {svg && <div className="heading-icon-container">{svg}</div>}
         {icon && <div className="heading-icon-container"><img src={icon} alt="icon" /></div>} <p className={`page-heading-name`}>{title}</p>
        </Grid>
        {children && <Grid className={`d-flex justify-content-end`} item xs={8} md={8}>
          <Stack direction="row" spacing={{ xs: 1, sm: 2, md: 2 }}>
            {children}
          </Stack>
        </Grid>}
      </Grid>
    </Box>
  );
}

export default Heading